import React from 'react';
import moment from 'moment';
import { Box } from '@material-ui/core';
import { Heading } from 'neon-design-system';
import { useArticleList } from '../../hooks/use-article-list';
import { getStartOfTheDay } from '../../../utils/date.utils';
import LinkList, { ListItemOrientation, ListItemType } from '../../ui/LinkList';
import { getArticleLink } from '../../../utils/link.utils';
import { randomizeArray, sliceArray } from '../../../utils/utils';

export interface LatestArticlesFromChannelProps {
	batchSize?: number;
	channelId: string;
	currentArticleId: string;
}

export const LatestArticlesFromChannel = (props: LatestArticlesFromChannelProps) => {
	const { channelId: premiumChannelId, currentArticleId, batchSize = 20 } = props;
	const dateFrom = new Date(getStartOfTheDay(moment().subtract(1, 'month').toDate())).toISOString();
	const queryArticles = useArticleList({ dateFrom, premiumChannelId, batchSize });

	const preparedArticles = sliceArray(randomizeArray(queryArticles.articles ?? []).filter(a => a._id !== currentArticleId));

	const articles = preparedArticles.map((article) => ({
		id: article._id,
		name: article.title,
		url: getArticleLink(article._id)
	}));

	if (queryArticles.loading || !articles.length) return <></>;

	return (
		<Box>
			<Heading styleName="title1">
				More from this channel
			</Heading>
			<Box mt={2}>
				<LinkList
					disableSort
					items={articles}
					orientation={ListItemOrientation.Vertical}
					displayType={ListItemType.Link}
					isSpacedVerticalLinks={true}
					source={'Recent Articles'}
				/>
			</Box>
		</Box>
	)
}

export default LatestArticlesFromChannel;
